import { render, staticRenderFns } from "./InitialSetup.vue?vue&type=template&id=03812672"
import script from "./InitialSetup.vue?vue&type=script&lang=js"
export * from "./InitialSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports